(() => {
  function initFinder(finder) {
    if (!finder || finder.dataset.finderInitialized === 'true') return;
    finder.dataset.finderInitialized = 'true';

    const state = {
      application: null,
      units: null,
      tool: null,
    };

    finder.addEventListener('click', (event) => {
      const option = event.target.closest('.finder-option');
      const backBtn = event.target.closest('.finder-back');
      const stepIndicator = event.target.closest('.finder-step-indicator');

      if (option) {
        handleOptionClick(option);
      } else if (backBtn) {
        goToStep(parseInt(backBtn.dataset.back, 10));
      } else if (stepIndicator) {
        const targetStep = parseInt(stepIndicator.dataset.step, 10);
        const currentStep = parseInt(finder.dataset.step, 10);
        if (targetStep < currentStep) {
          goToStep(targetStep);
        }
      }
    });

    function handleOptionClick(option) {
      const currentStep = parseInt(finder.dataset.step, 10);
      const value = option.dataset.value;
      const nextStep = option.dataset.next;
      const collection = option.dataset.collection;

      const siblings = option.parentElement.querySelectorAll('.finder-option');
      siblings.forEach((sibling) => sibling.classList.remove('finder-option--selected'));
      option.classList.add('finder-option--selected');

      if (currentStep === 1) state.application = value;
      if (currentStep === 2) state.units = value;
      if (currentStep === 3) state.tool = value;

      if (collection) {
        redirectToCollection(collection);
      } else if (nextStep) {
        goToStep(parseInt(nextStep, 10));
      }
    }

    function goToStep(step) {
      finder.dataset.step = step;

      finder.querySelectorAll('.finder-step-panel').forEach((panel) => {
        const panelStep = parseInt(panel.dataset.step, 10);
        panel.classList.toggle('finder-step-panel--active', panelStep === step);
        panel.hidden = panelStep !== step;
      });

      finder.querySelectorAll('.finder-step-indicator').forEach((indicator) => {
        const indicatorStep = parseInt(indicator.dataset.step, 10);
        const isActive = indicatorStep === step;
        indicator.classList.toggle('finder-step-indicator--active', isActive);
        indicator.classList.toggle('finder-step-indicator--complete', indicatorStep < step);
        indicator.setAttribute('aria-selected', String(isActive));
      });
    }

    function redirectToCollection(collectionHandle) {
      let url = `/collections/${collectionHandle}`;
      const params = [];

      if (state.units && state.units !== 'both') {
        params.push(`filter.v.m.specs.graduations=${encodeURIComponent(state.units)}`);
      }
      if (state.application) {
        params.push(`filter.v.m.specs.use_case=${encodeURIComponent(state.application)}`);
      }

      if (params.length > 0) {
        url += `?${params.join('&')}`;
      }

      window.location.href = url;
    }
  }

  function initAll(root = document) {
    root.querySelectorAll('#ruler-finder').forEach(initFinder);
  }

  function hydrateDeferredFinder(root = document) {
    const template = root.querySelector('[data-lance-finder-template]');
    const shell = root.querySelector('[data-lance-finder-shell]');
    if (!template || !shell) return;

    if (shell.dataset.finderHydrated === 'true') return;

    const hydrate = () => {
      if (shell.dataset.finderHydrated === 'true') return;
      shell.dataset.finderHydrated = 'true';

      // Replace the lightweight shell with the full wizard markup.
      shell.outerHTML = template.innerHTML;
      template.remove();

      // Initialize event handlers on the injected wizard.
      initAll(root);
    };

    // Prefer user intent. Hydrate on interaction so any resulting layout shift is attributed to user input.
    const startBtn = shell.querySelector('[data-lance-finder-start]');
    if (startBtn) {
      startBtn.addEventListener('click', hydrate, { once: true });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    hydrateDeferredFinder();
    initAll();
  });
  document.addEventListener('shopify:section:load', (event) => {
    hydrateDeferredFinder(event.target);
    initAll(event.target);
  });
})();
